export default "__VITE_ASSET__CZ5oX0s$__"